import { motion } from 'framer-motion';

export function FlatHandIllustration() {
  return (
    <svg viewBox="0 0 200 200" className="absolute inset-0 h-full w-full">
      <defs>
        <radialGradient id="flathand-zone" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="hsl(var(--primary))" stopOpacity="0.45" />
          <stop offset="100%" stopColor="hsl(var(--primary))" stopOpacity="0" />
        </radialGradient>
        <radialGradient id="flathand-contact" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="hsl(var(--secondary))" stopOpacity="0.35" />
          <stop offset="100%" stopColor="hsl(var(--secondary))" stopOpacity="0" />
        </radialGradient>
        <filter id="flathand-glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="2.5" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* Ambient zone glow */}
      <circle cx="100" cy="110" r="70" fill="url(#flathand-zone)" />

      {/* Two thigh curves — pelvis at top-center, knees at bottom corners */}
      <path
        d="M 88 32 C 72 78, 55 130, 24 196"
        fill="none"
        stroke="hsl(var(--secondary))"
        strokeWidth="1.6"
        strokeLinecap="round"
        opacity="0.7"
      />
      <path
        d="M 112 32 C 128 78, 145 130, 176 196"
        fill="none"
        stroke="hsl(var(--secondary))"
        strokeWidth="1.6"
        strokeLinecap="round"
        opacity="0.7"
      />

      {/* Inner pelvic anchor */}
      <ellipse
        cx="100"
        cy="42"
        rx="14"
        ry="8"
        fill="none"
        stroke="hsl(var(--secondary))"
        strokeWidth="1.2"
        opacity="0.4"
      />

      {/* Contact glow that breathes with the hand */}
      <motion.circle
        cx="100"
        cy="105"
        r="34"
        fill="url(#flathand-contact)"
        animate={{ opacity: [0.45, 0.85, 0.45] }}
        transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
      />

      {/* Hand glyph — palm-down, fingers extending toward the body */}
      <motion.g
        filter="url(#flathand-glow)"
        animate={{ x: [-18, 18, -18], y: [0, -3, 0, 3, 0], scale: [1, 1.04, 1] }}
        transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
      >
        <g transform="translate(100 105)">
          {/* Palm */}
          <ellipse
            cx="0"
            cy="-2"
            rx="16"
            ry="11"
            fill="hsl(var(--accent))"
            opacity="0.85"
          />
          {/* Wrist taper at top */}
          <rect
            x="-7"
            y="-16"
            width="14"
            height="8"
            rx="4"
            fill="hsl(var(--accent))"
            opacity="0.7"
          />
          {/* Fingers (4) fanning downward */}
          <ellipse cx="-10" cy="11" rx="3" ry="7" fill="hsl(var(--accent))" opacity="0.85" />
          <ellipse cx="-3.5" cy="13" rx="3" ry="8" fill="hsl(var(--accent))" opacity="0.85" />
          <ellipse cx="3.5" cy="13" rx="3" ry="8" fill="hsl(var(--accent))" opacity="0.85" />
          <ellipse cx="10" cy="11" rx="3" ry="7" fill="hsl(var(--accent))" opacity="0.85" />
          {/* Thumb on the side */}
          <ellipse
            cx="-15"
            cy="2"
            rx="3"
            ry="6"
            fill="hsl(var(--accent))"
            opacity="0.85"
            transform="rotate(-25 -15 2)"
          />
        </g>
      </motion.g>
    </svg>
  );
}
